import { action, createRequestTypes } from '@/utils/actions.utils'
import { ordersService } from '@/services'

export const EMPTY_ORDERS_LIST = 'EMPTY_ORDERS_LIST'
const emptyOrdersList = () => {
	return {
		type: EMPTY_ORDERS_LIST
	}
}

export const FETCH_ORDERS_LIST = createRequestTypes('FETCH_ORDERS_LIST')
const fetchOrdersList = (config) => {
	const { itemsToLoad, itemsPerPage, page, search, language, status, resetList = false } = config
	return async (dispatch) => {
		try {
			await dispatch(request({ itemsToLoad, resetList }))

			const res = await ordersService.fetchOrdersList({
				itemsPerPage,
				page,
				search,
				language,
				status
			})

			if (resetList) {
				dispatch(ordersActions.emptyOrdersList())
			}

			return dispatch(
				success({
					itemsToLoad,
					...res.data
				})
			)
		} catch (error) {
			return dispatch(failure({ itemsToLoad }, error))
		}
	}

	function request(payload) {
		return action(FETCH_ORDERS_LIST.REQUEST, payload)
	}
	function success(payload) {
		return action(FETCH_ORDERS_LIST.SUCCESS, payload)
	}
	function failure(payload, err) {
		return action(FETCH_ORDERS_LIST.FAILURE, payload, err, false)
	}
}

const ordersActions = {
	emptyOrdersList,
	fetchOrdersList
}

export default ordersActions
